import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { Fragment, SetStateAction, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { TableInstanceType } from '../../../../../../baseComponents/TwinTable/types'
import { OnSubmit } from '../../../../../../forms/TwinForm/types'
import useEditDeleteModal from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { getUserPermissions } from '../../../../../../utils/reducers/getters'
import { TableCustomerAddresses } from '../../../CustomerAddresses'
import ModalCECustomerAddress from '../../../CustomerAddresses/ModalCECustomerAddress'
import ModalDeleteCustomerAddress from '../../../CustomerAddresses/ModalDeleteCustomerAddress'
import { CustomerDashboardAddButton, CustomerDashboardSeeAllLink } from '../../SpecificComponents'

interface CustomerAddressDashboardProps extends CustomerAddressDashboardLogicProps {
    title: string
    allRowData: CustomerModelType
}

const CustomerAddressDashboard: React.FC<CustomerAddressDashboardProps> = ({ title, allRowData }) => {
    const { t } = useTwinTranslation()
    const { setTableInstance, tableInstance } = useCustomerAddressDashboardLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const userPermissions = getUserPermissions('customer.profile.address')
    return (
        <div className='flex flex-col flex-auto gap-10'>
            <div className='flex flex-wrap justify-between gap-5'>
                <div className='flex items-center gap-x-10'>
                    <h3>{title}</h3>
                    <CustomerDashboardSeeAllLink customerTab='address' customerType={allRowData?.customer_type} />
                </div>
                <CustomerDashboardAddButton userPermissions={userPermissions || { n: 4, permission: 'delete' }} CreateModalComponent={ModalCECustomerAddress} onSubmit={updateTableInstance} text={t('newAddress', 'Nueva dirección')} />
            </div>
            <TableCustomerAddress userPermissions={userPermissions || { n: 4, permission: 'delete' }} onSubmit={updateTableInstance} {...{ setTableInstance }} tableInstance={tableInstance} />
        </div>
    )
}

interface CustomerAddressDashboardLogicProps { }

const useCustomerAddressDashboardLogic = () => {
    const [tableInstance, setTableInstance] = useState<TableInstanceType>(null)
    return { setTableInstance, tableInstance }
}

interface TableCustomerAddressProps extends ComponentWithPermissions {
    onSubmit: OnSubmit
    setTableInstance: React.Dispatch<SetStateAction<TableInstanceType>>
    tableInstance: TableInstanceType
}

const TableCustomerAddress: React.FC<TableCustomerAddressProps> = ({ onSubmit, setTableInstance, userPermissions, tableInstance }) => {
    const { id } = useParams()
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <Fragment>
            <TableCustomerAddresses name='customerAddressesDashboard' className='small_simple_table' extraWhereParams={{ 'CustomerId': id }} setOpened={setOpenModal} setTableInstance={setTableInstance} tableInstance={tableInstance} userPermissions={userPermissions} hideLoadFiltersButton={true} />
            {openModal?.type === 'edit' && <ModalCECustomerAddress {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} userPermissions={userPermissions} allRowData={openModal?.allRowData} basicData={{}} />}
            {openModal?.type === 'delete' && <ModalDeleteCustomerAddress {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} userPermissions={userPermissions} allRowData={openModal?.allRowData} basicData={{}} />}
        </Fragment>
    )
}

export default CustomerAddressDashboard